'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = {
  local: "http://localhost:" + (process.env.REACT_APP_LOCAL_PORT || 8080) + "/",
  dev: 'https://dev-api-au.medipass.io/',
  'pre-prod': 'https://api-au-blue.medipass.io/',
  prod: 'https://api-au.medipass.io/',
  staging: 'https://stg-api-au.medipass.io/',
  perf: 'https://perf-api-au.medipass.io/',
  dr: 'https://dr-api-au.medipass.io/'
};

exports["default"] = core;
